const ODS_PARALLAX_SELECTOR = '[data-ods-parallax]';

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

class ODSParallax {
  constructor(element) {
    this.element = element;
    this.rafId = null;
    this.isActive = false;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.scaleStart = 1.1;
    this.scaleEnd = 1;
    this.update = this.update.bind(this);
    this.requestUpdate = this.requestUpdate.bind(this);
    this.handleMotionChange = this.handleMotionChange.bind(this);
  }

 init() {
  this.reduceMotion.addEventListener?.('change', this.handleMotionChange);

  const styles = getComputedStyle(this.element);

  this.scaleStart =
    parseFloat(styles.getPropertyValue('--ods-parallax-scale-start')) || 1.15;

  this.scaleEnd =
    parseFloat(styles.getPropertyValue('--ods-parallax-scale-end')) || 1;

  if (this.reduceMotion.matches) {
    this.reset();
    return;
  }

  this.isActive = true;

  window.addEventListener('scroll', this.requestUpdate, { passive: true });
  window.addEventListener('resize', this.requestUpdate, { passive: true });

  this.requestUpdate();
}
requestUpdate() {
  if (!this.isActive || this.rafId !== null) return;

  this.rafId = requestAnimationFrame(this.update);
}

update() {
  this.rafId = null;

  const rect = this.element.getBoundingClientRect();

  const styles = getComputedStyle(this.element);
  const isDesktop = window.matchMedia('(min-width: 750px)').matches;

  const desktopMode =
  this.element.dataset.odsDesktopParallaxMode || 'dynamic';

   /* ==========================================
     ODS-13.14B — DESKTOP ANCHORED MODE
     ========================================== */

if (isDesktop && desktopMode === 'anchored') {
  this.element.style.setProperty(
    '--ods-parallax-anchor-y',
    '0px'
  );

  this.element.style.setProperty(
    '--ods-parallax-scale-current',
    '1'
  );

  return;
}

if (isDesktop && desktopMode === 'off') {
  this.element.style.setProperty(
    '--ods-parallax-anchor-y',
    '0px'
  );

  this.element.style.setProperty(
    '--ods-parallax-scale-current',
    '1'
  );

  return;
}

this.element.style.setProperty(
  '--ods-parallax-anchor-y',
  '0px'
);

  const startPoint =
    parseFloat(styles.getPropertyValue('--ods-parallax-start-point')) || 0;

  const endPoint =
    parseFloat(styles.getPropertyValue('--ods-parallax-end-point')) || 1;

  const rawProgress = clamp(
    -rect.top / rect.height,
    0,
    1
  );

  const progress = clamp(
    (rawProgress - startPoint) /
    Math.max(endPoint - startPoint, 0.001),
    0,
    1
  );

  this.element.style.setProperty(
    '--ods-parallax-progress',
    progress.toFixed(4)
  );

  const scale =
    this.scaleStart +
    (this.scaleEnd - this.scaleStart) * progress;

  this.element.style.setProperty(
    '--ods-parallax-scale-current',
    scale.toFixed(4)
  );
}


  handleMotionChange(event) {
    if (event.matches) {
      this.destroyListeners();
      this.reset();
    } else {
      this.isActive = true;

      window.addEventListener('scroll', this.requestUpdate, { passive: true });
      window.addEventListener('resize', this.requestUpdate, { passive: true });

      this.requestUpdate();
    }
  }

  reset() {
    this.isActive = false;
    this.element.style.setProperty('--ods-parallax-progress', '1');
    this.element.style.setProperty(
    '--ods-parallax-scale-current',
    '1'
   );

  }

  destroyListeners() {
    this.isActive = false;

    window.removeEventListener('scroll', this.requestUpdate);
    window.removeEventListener('resize', this.requestUpdate);

    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }
}

const initODSParallax = (root = document) => {
  const elements = [];

  if (root.matches?.(ODS_PARALLAX_SELECTOR)) {
    elements.push(root);
  }

  root.querySelectorAll?.(ODS_PARALLAX_SELECTOR).forEach((element) => {
    elements.push(element);
  });

  elements.forEach((element) => {
    if (element.dataset.odsParallaxReady === 'true') return;

    const instance = new ODSParallax(element);
    instance.init();

    element.dataset.odsParallaxReady = 'true';
  });
};


/* ==========================================================
   ODS PARALLAX — BOOTSTRAP
========================================================== */

const bootODSParallax = () => {
  initODSParallax(document);
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    bootODSParallax,
    { once: true }
  );
} else {
  bootODSParallax();
}

/* Shopify Theme Editor — reinitialize section when reloaded */
document.addEventListener('shopify:section:load', (event) => {
  initODSParallax(event.target);
});